module.exports = __webpack_public_path__ + "img/2-5.72b3d8a9.svg";